// eslint-disable-next-line import/prefer-default-export
export enum Unit {
    Mm = 'mm',
    Cm = 'cm',
    M = 'm',
    Km = 'km',
}
